(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-anti-config]').textContent).variants;
    const find = id => variants.find(v => v.id === Number(id));
    const money = cents => new Intl.NumberFormat('es-MX', {style:'currency',currency:'MXN'}).format(cents / 100);
    const get = name => root.querySelector(`[data-anti-${name}]`);
    const status = get('status');
    const form = root.querySelector('form');
    let slots = [find(root.dataset.initial)?.id || null];
    let busy = false;
    let uncertain = false;
    let helpVariant = null;
    let urlRevision = 0;
    get('help-kg').addEventListener('input', () => {
      const raw = get('help-kg').value.trim().replace(',', '.');
      const kg = /^\d+(?:\.\d+)?$/.test(raw) ? Number(raw) : NaN;
      const matches = variants.filter(v => {
        const range = v.title.match(/(\d+(?:[.,]\d+)?)\s*(?:-|–|a)\s*(\d+(?:[.,]\d+)?)\s*kg/i);
        return range && kg > Number(range[1].replace(',', '.')) && kg < Number(range[2].replace(',', '.'));
      });
      helpVariant = matches.length === 1 && kg > 0 ? matches[0] : null;
      get('help-result').hidden = !raw;
      get('help-match').textContent = helpVariant ? `Presentación ${helpVariant.title}` : 'Confirma la presentación';
      get('help-note').textContent = helpVariant ? 'Tu peso está dentro de este rango. Verifica las indicaciones del empaque antes de usarlo.' : 'Revisa el peso y los límites del empaque. Si está en un límite o fuera de los rangos, consulta a tu veterinario.';
      get('help-use').hidden = !helpVariant;
      get('help-use').disabled = !helpVariant?.available;
      root.querySelectorAll('[data-anti-help-range]').forEach(row=>row.classList.toggle('is-match',Number(row.dataset.antiHelpRange)===helpVariant?.id));
    });
    get('help').addEventListener('click',event=>{
      const rect = get('help').getBoundingClientRect();
      if (event.target === get('help') && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) get('help').close();
    });
    const recommendations = root.querySelector('[data-fp-auto-recommendations]');
    if (recommendations) {
      const load = () => import(root.dataset.recommendationsModule).then(module=>module.initAutomaticRecommendations(root)).catch(()=>{});
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries=>{
          if (!entries.some(entry=>entry.isIntersecting)) return;
          observer.disconnect();
          load();
        },{rootMargin:'400px'});
        observer.observe(root.querySelector('.fp-anti__review-zone'));
      } else load();
    }
    function steps(variant) {
      const rule = variant?.volume;
      const raw = rule?.discountData?.discountSteps;
      if (!Array.isArray(raw) || rule.discountData.discountProductCombination !== 'ANY_COMBINATION') return [{quantity:1,rate:1}];
      const result = raw.map(s => ({
        quantity:Number(s.minProductCount),
        rate:s.discountType === 'EMPTY' ? 1 : Number(s.discountAmount),
        badge:rule.widgetConfig?.general?.widgetSteps?.[raw.indexOf(s)]?.label || '',
        valid:(s.discountType === 'EMPTY' || s.discountType === 'RELATIVE_DECREASE') && s.unitDiscont === 1,
      }));
      if (result.some(s => !s.valid || !Number.isSafeInteger(s.quantity) || s.quantity < 1 || s.quantity > 20 || s.rate <= 0 || s.rate > 1)) return [{quantity:1,rate:1}];
      result.sort((a,b) => a.quantity - b.quantity);
      const best = result.at(-1);
      if (best.rate < 1 && best.rate === Math.min(...result.map(t=>t.rate)) && !best.badge) best.badge = 'Mejor precio';
      return result;
    }
    function rateFor(v, count) {
      return steps(v).filter(s => s.quantity <= count).at(-1)?.rate || 1;
    }
    function estimatedTotal(ids) {
      const groups = new Map();
      ids.forEach(id => {
        const v = find(id);
        if (!v) return;
        const key = v.volume?.widgetId || String(v.id);
        groups.set(key,(groups.get(key) || 0) + 1);
      });
      return ids.reduce((sum,id) => {
        const v = find(id);
        return sum + (v ? Math.round(v.price * rateFor(v,groups.get(v.volume?.widgetId || String(v.id)))) : 0);
      },0);
    }
    function counts() {
      const result = new Map();
      slots.filter(Boolean).forEach(id => result.set(id,(result.get(id) || 0) + 1));
      return result;
    }
    function validCount(v,count) {
      return v?.available && count >= v.min && (count - v.min) % v.increment === 0 && (v.max == null || count <= v.max);
    }
    function button(label,attr,value) {
      const el = document.createElement('button');
      el.type = 'button';
      el.textContent = label;
      el.setAttribute(`data-anti-${attr}`,String(value));
      return el;
    }
    function render() {
      const first = find(slots[0]);
      const missing = slots.indexOf(null);
      const ready = missing < 0;
      const actualCounts = counts();
      const invalid = [...actualCounts].find(([id,count]) => !validCount(find(id),count));
      const tiers = steps(first || variants[0]);
      if (!tiers.some(t => t.quantity === slots.length)) tiers.push({quantity:slots.length,rate:rateFor(first,slots.length)});
      get('promo').textContent = tiers.some(t => t.rate < 1) ? 'Compra más, ahorra más' : '';
      root.querySelectorAll('[data-anti-weight]').forEach(el => {
        el.setAttribute('aria-pressed',String(Number(el.dataset.antiWeight) === first?.id));
        el.disabled = busy || !find(el.dataset.antiWeight)?.available;
      });
      get('weight-note').textContent = first ? `Dosis para ${first.title}` : 'Elige el peso actual';
      get('weight-note').classList.toggle('is-selected',!!first);
      const base = slots.reduce((sum,id) => sum + (find(id)?.price || 0),0);
      const total = estimatedTotal(slots);
      const months = Number(root.dataset.protectionMonths);
      const monthly = get('monthly');
      monthly.hidden = !ready || months <= 0 || !Number.isFinite(months);
      monthly.textContent = monthly.hidden ? '' : `Equivale a ${money(total / (slots.length * months))} por mes de protección contra pulgas${slots.length > 1 ? ' · promedio por caja' : ''}.`;
      get('total').textContent = money(first ? total : Math.min(...variants.map(v=>v.price)));
      get('from').textContent = ready ? '' : first ? 'Selección parcial' : 'Desde';
      get('original').hidden = !ready || base <= total;
      get('original').textContent = money(base);
      get('estimate').textContent = !ready ? 'Elige el peso de cada caja para confirmar el total.' : base > total ? `Ahorras ${money(base-total)}` : '';
      get('estimate').hidden = ready && base <= total;
      get('tiers').replaceChildren();
      tiers.sort((a,b)=>a.quantity-b.quantity).forEach(tier => {
        const el = button('', 'tier',tier.quantity);
        el.setAttribute('aria-pressed',String(slots.length === tier.quantity));
        el.disabled = busy;
        const title = document.createElement('strong');
        const protectionMonths = Number(root.dataset.protectionMonths || 0);
        title.textContent = protectionMonths > 0
          ? `${tier.quantity} ${tier.quantity === 1 ? 'dosis' : 'dosis'}`
          : `${tier.quantity} ${tier.quantity === 1 ? 'caja' : 'cajas'}`;
        const sub = document.createElement('small');
        sub.textContent = protectionMonths > 0
          ? `${protectionMonths * tier.quantity} meses de protección`
          : tier.rate < 1 ? `-${Math.round((1-tier.rate)*100)}% por cantidad` : 'Precio normal';
        const price = document.createElement('strong');
        price.textContent = first ? money(estimatedTotal(Array(tier.quantity).fill(first.id))) : 'Elige peso';
        const amount = document.createElement('span');
        amount.className = 'fp-anti__tier-price';
        amount.append(price);
        if (first && tier.rate < 1) {
          const saving = document.createElement('small');
          saving.textContent = `Ahorras ${money(first.price*tier.quantity-estimatedTotal(Array(tier.quantity).fill(first.id)))}`;
          amount.append(saving);
        }
        const info = document.createElement('span');
        info.append(title,sub);
        if (tier.badge && !tier.badge.includes('{{')) {
          const badge = document.createElement('span');
          badge.className = 'fp-anti__tier-badge';
          badge.textContent = tier.badge;
          title.append(' ',badge);
        }
        el.append(info,amount);
        get('tiers').append(el);
      });
      get('boxes').hidden = slots.length < 2;
      get('same').hidden = !first || slots.every(id=>id===first.id);
      get('same').textContent = first ? `Todas de ${first.title}` : 'Todas del mismo peso';
      get('same').disabled = busy;
      const boxList = get('box-list');
      if (slots.length < 2) {
        if (boxList.childElementCount) boxList.replaceChildren();
      } else {
        const focused = document.activeElement?.closest('[data-anti-box-index]');
        const restore = focused ? {index:focused.dataset.antiBoxIndex,id:focused.dataset.antiBoxWeight} : null;
        boxList.replaceChildren();
        slots.forEach((id,index) => {
          const box = document.createElement('div');
          box.className = 'fp-anti__box' + (id ? '' : ' is-pending');
          const label = document.createElement('strong');
          label.textContent = `Caja ${index+1} · ${id ? find(id).title : 'elige su peso'}`;
          const options = document.createElement('div');
          options.className = 'fp-anti__box-weights';
          variants.forEach(v => {
            const el = button(v.title,'box-weight',v.id);
            el.dataset.antiBoxIndex = String(index);
            el.setAttribute('aria-label',`Caja ${index+1}: ${v.title}`);
            el.setAttribute('aria-pressed',String(id===v.id));
            const assigned = (actualCounts.get(v.id)||0) + (id===v.id?0:1);
            el.disabled = busy || !v.available || (v.max != null && assigned > v.max);
            options.append(el);
          });
          box.append(label,options);
          boxList.append(box);
        });
        if (restore) root.querySelector(`[data-anti-box-index="${restore.index}"][data-anti-box-weight="${restore.id}"]`)?.focus({preventScroll:true});
      }
      get('id').value = first?.id || '';
      get('quantity').value = String(slots.length);
      get('add').disabled = busy || uncertain;
      get('add').classList.toggle('is-pending',!ready || !!invalid);
      get('add-text').textContent = busy ? 'Agregando…' : uncertain ? 'Revisa tu carrito antes de agregar' : missing >= 0 ? `Elige el peso${slots.length > 1 ? ` de la caja ${missing+1}` : ` de tu ${root.dataset.species}`}` : invalid ? 'Revisa la cantidad disponible' : `Agregar ${slots.length} ${slots.length===1?'caja':'cajas'} · ${money(total)}`;
      get('sticky-add').disabled = busy || uncertain;
      get('sticky-add').classList.toggle('is-pending',!ready || !!invalid);
      get('sticky-add').textContent = busy ? 'Agregando…' : uncertain ? 'Revisa tu carrito' : missing >= 0 ? `Elegir peso${slots.length>1?` caja ${missing+1}`:''}` : invalid ? 'Revisar cantidad' : `Agregar ${slots.length}`;
      get('sticky-price').textContent = money(first ? total : Math.min(...variants.map(v=>v.price)));
    }
    root.addEventListener('click',event => {
      const el = event.target.closest('button');
      if (!el || busy) return;
      if (el.matches('[data-fp-comp-toggle],[data-fp-comp-variant-btn]')) {
        event.stopPropagation();
        const compForm = el.closest('[data-fp-comp-form]');
        if (el.hasAttribute('data-fp-comp-toggle')) {
          const picker = compForm.querySelector('[data-fp-comp-picker]');
          picker.classList.toggle('is-hidden');
          el.setAttribute('aria-expanded',String(!picker.classList.contains('is-hidden')));
        } else {
          compForm.querySelector('[data-fp-comp-variant-id]').value = el.dataset.variantId;
          compForm.querySelectorAll('[data-fp-comp-variant-btn]').forEach(button=>button.classList.toggle('is-selected',button===el));
          const submit = compForm.querySelector('[data-fp-comp-submit]');
          submit.classList.remove('is-hidden');
          submit.textContent = `Agregar ${el.dataset.variantTitle}`;
          compForm.querySelector('[data-fp-comp-toggle]').textContent = el.dataset.variantTitle;
          compForm.closest('.fp-product-premium__complementary-item').querySelector('[data-fp-comp-price]').textContent = el.dataset.variantPrice;
        }
        return;
      }
      if (el.matches('[data-anti-weight],[data-anti-tier],[data-anti-box-weight],[data-anti-same]')) status.textContent = '';
      if (el.hasAttribute('data-anti-weight')) {
        slots[0] = Number(el.dataset.antiWeight);
        const v = find(slots[0]);
        get('spec').textContent = v.title;
        const revision = ++urlRevision;
        requestAnimationFrame(() => setTimeout(() => {
          if (revision !== urlRevision) return;
          const url = new URL(location.href);
          url.searchParams.set('variant',v.id);
          history.replaceState(null,'',url);
        }, 0));
        if (v.image) {
          const image = getImage();
          if (image && image.src !== new URL(v.image,location.href).href) {
            image.src = v.image;
            image.removeAttribute('srcset');
          }
          if (image && v.image_alt) image.alt = v.image_alt;
        }
        render();
      } else if (el.hasAttribute('data-anti-tier')) {
        const count = Number(el.dataset.antiTier);
        slots = Array.from({length:count},(_,i)=>slots[i] || null);
        render();
      } else if (el.hasAttribute('data-anti-box-weight')) {
        slots[Number(el.dataset.antiBoxIndex)] = Number(el.dataset.antiBoxWeight);
        render();
      } else if (el.hasAttribute('data-anti-same')) {
        const first = find(slots[0]);
        if (!validCount(first,slots.length)) {status.textContent='No hay suficientes unidades de ese peso. Elige otros pesos o reduce las cajas.';return;}
        slots.fill(first.id);
        render();
      } else if (el.hasAttribute('data-anti-image')) {
        const image = getImage();
        image.src = el.dataset.antiImage;
        image.removeAttribute('srcset');
        if (el.dataset.antiImageAlt) image.alt = el.dataset.antiImageAlt;
        root.querySelectorAll('[data-anti-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===el)));
      } else if (el.hasAttribute('data-anti-cp')) {
        document.querySelector('[data-fp-open-global-zip-modal]')?.click();
      } else if (el.hasAttribute('data-anti-more')) {
        const expanded = el.getAttribute('aria-expanded') !== 'true';
        el.setAttribute('aria-expanded',String(expanded));
        el.textContent = expanded ? 'Ver menos' : 'Ver más';
        get('description').classList.toggle('is-expanded',expanded);
      } else if (el.hasAttribute('data-anti-help-open')) {
        get('help-kg').value = '';
        get('help-kg').dispatchEvent(new Event('input'));
        get('help').showModal();
      } else if (el.hasAttribute('data-anti-help-use') && helpVariant?.available) {
        root.querySelector(`[data-anti-weight="${helpVariant.id}"]`)?.click();
        get('help').close();
      }
      else if (el.hasAttribute('data-anti-help-close')) get('help').close();
    });
    function getImage() {return root.querySelector('.fp-anti__main-image');}
    form.addEventListener('submit',async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || uncertain) return;
      const missing = slots.indexOf(null);
      if (missing >= 0) {
        status.textContent = `Elige el peso de ${slots.length>1?`la caja ${missing+1}`:`tu ${root.dataset.species}`} para continuar.`;
        const target = slots.length>1 ? root.querySelector(`[data-anti-box-index="${missing}"]:not(:disabled)`) : root.querySelector('[data-anti-weight]:not(:disabled)');
        target?.focus({preventScroll:true});
        target?.scrollIntoView({block:'center',behavior:'instant'});
        return;
      }
      const quantities = counts();
      if ([...quantities].some(([id,count])=>!validCount(find(id),count))) {status.textContent='Revisa la disponibilidad o reduce las cajas antes de continuar.';return;}
      busy = true;
      status.textContent = 'Agregando tus cajas al carrito…';
      render();
      let response;
      try {
        const base = window.Shopify?.routes?.root || '/';
        response = await fetch(`${base}cart/add.js`,{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))}),
        });
        if (!response.ok) {
          uncertain = response.status >= 500;
          status.textContent = uncertain ? 'No pudimos confirmar el resultado. Revisa tu carrito antes de volver a agregar.' : 'La disponibilidad cambió. Revisa tu carrito y las cantidades antes de volver a agregar.';
          const link = document.createElement('a');
          link.href = `${base}cart`;
          link.textContent = ' Ver carrito';
          status.append(link);
          return;
        }
        const data = await response.json();
        if (!Array.isArray(data.items) || data.items.length !== quantities.size) throw Error('Unconfirmed cart response');
        location.assign(`${base}cart`);
      } catch {
        uncertain = true;
        status.textContent = 'No pudimos confirmar el resultado. Revisa tu carrito antes de volver a agregar.';
        const link = document.createElement('a');
        link.href = `${window.Shopify?.routes?.root || '/'}cart`;
        link.textContent = ' Ver carrito';
        status.append(link);
      } finally {busy=false;render();}
    },true);
    function updatePostal(event) {
      const label = document.querySelector('[data-fp-header-zip-chip-text]');
      const zip = event ? event.detail?.zip : label?.textContent.match(/\b\d{5}\b/)?.[0];
      get('delivery').textContent = zip ? `Entrega a CP ${zip}. Consulta tarifas y disponibilidad para tus productos en el carrito.` : 'Consulta las opciones de entrega para tu código postal en el carrito.';
    }
    window.addEventListener('fp:zip-updated',updatePostal);
    const postalLabel = document.querySelector('[data-fp-header-zip-chip-text]');
    if (postalLabel) {
      const observer = new MutationObserver(()=>updatePostal());
      observer.observe(postalLabel,{childList:true,characterData:true,subtree:true});
    }
    updatePostal();
    render();
  }
  const boot = () => document.querySelectorAll('[data-fp-anti]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
